const esc = (s: string) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')

// ── JSON ──────────────────────────────────────────────────────────────────────

export function highlightJson(val: unknown): string {
  if (val === null || val === undefined) return ''
  let obj: unknown = val
  if (typeof val === 'string') {
    try { obj = JSON.parse(val) } catch { return esc(val) }
  }
  const raw = JSON.stringify(obj, null, 2)
  return raw.replace(
    /("(?:[^"\\]|\\.)*")\s*:|("(?:[^"\\]|\\.)*")|(true|false|null)|(-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)/g,
    (match, key, str, bool, num) => {
      if (key !== undefined) return `<span class="syn-key">${esc(key)}</span>:`
      if (str !== undefined) return `<span class="syn-str">${esc(str)}</span>`
      if (bool !== undefined) return `<span class="syn-bool">${bool}</span>`
      if (num !== undefined) return `<span class="syn-num">${num}</span>`
      return esc(match)
    }
  )
}

// ── XML ───────────────────────────────────────────────────────────────────────

function prettyXml(xml: string): string {
  let formatted = ''
  let depth = 0
  let inlineText = false
  const tab = '  '
  const clean = xml.replace(/>\s+</g, '><').trim()
  clean.split(/(<[^>]+>)/).forEach((part) => {
    if (!part) return
    if (part.startsWith('</')) {
      depth--
      if (inlineText) {
        // Pull closing tag onto the same line as the text value
        formatted = formatted.replace(/\n$/, '') + part + '\n'
        inlineText = false
      } else {
        formatted += tab.repeat(depth) + part + '\n'
      }
    } else if (part.startsWith('<?') || part.startsWith('<!')) {
      formatted += tab.repeat(depth) + part + '\n'
      inlineText = false
    } else if (part.startsWith('<') && !part.endsWith('/>')) {
      formatted += tab.repeat(depth) + part + '\n'
      depth++
      inlineText = false
    } else if (part.startsWith('<') && part.endsWith('/>')) {
      formatted += tab.repeat(depth) + part + '\n'
      inlineText = false
    } else {
      // text node — attach to previous line (trim surrounding whitespace/newlines)
      const text = part.trim()
      if (text) {
        formatted = formatted.replace(/\n$/, '') + text + '\n'
        inlineText = true
      }
    }
  })
  return formatted.trim()
}

export function highlightXml(xml: string): string {
  if (!xml) return ''
  const formatted = prettyXml(xml)

  return formatted.split(/(<[^>]*>)/).map(part => {
    if (!part) return ''
    if (!part.startsWith('<')) return esc(part)

    const e = esc(part)
    if (e.startsWith('&lt;?') || e.startsWith('&lt;!')) {
      return `<span class="syn-xml-pi">${e}</span>`
    }
    return e
      .replace(/^(&lt;\/?)([\w:.-]+)/, (_, b, name) =>
        `<span class="syn-xml-bracket">${b}</span><span class="syn-key">${name}</span>`)
      .replace(/([\w:.-]+)(=)(&quot;.*?&quot;)/g, (_, attr, eq, val) =>
        `<span class="syn-xml-attr">${attr}</span>${eq}<span class="syn-str">${val}</span>`)
      .replace(/(\/?&gt;)$/, b => `<span class="syn-xml-bracket">${b}</span>`)
  }).join('')
}
